import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_DEPOSIT_HISTORY:
      return { ...action.depositHistory };
    default: return state;
  }
};
